import axios from 'axios'
import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../store/modules/rootReducer'
import { refreshTokenRequest, signOut } from '../store/modules/auth/actions'
// import history from './history'

const ecommerceApi = axios.create({
  baseURL:
    process.env.REACT_APP_API_URL + '/ecommerce' || 'https://dev-api.direcaoconcursos.com.br',
  // baseURL: 'http://localhost:4251'
})

const learningApi = axios.create({
  baseURL:
    process.env.REACT_APP_API_URL + '/learning' ||
    'https://dev-api.direcaoconcursos.com.br/learning',
  // baseURL: 'http://localhost:4251'
})

const coreApi = axios.create({
  baseURL: process.env.REACT_APP_API_DC_CORE_SERVICES,
})

const ApiInterceptor = () => {
  const dispatch = useDispatch()
  const { refresh_token, token } = useSelector((state: RootState) => state.auth)

  // Request interceptor: Injeta o token do Redux em todas as requisições
  const reqInterceptor = useCallback(
    (config) => {
      // Sempre usa o token do Redux (fonte única da verdade)
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    },
    [token]
  )

  const resInterceptor = useCallback((response) => {
    return response
  }, [])

  let oldToken = ''

  const errInterceptor = useCallback(
    async (error) => {
      const originalRequest = error.config

      // Handling network errors and multiple refresh token requests
      if (!error.response || oldToken === error.config.headers.Authorization) {
        return Promise.reject(error)
      }

      if (error.response?.status === 401 && !error.response?.data?.message) {
        if (refresh_token) {
          // eslint-disable-next-line react-hooks/exhaustive-deps
          oldToken = originalRequest.headers.Authorization
          await dispatch(refreshTokenRequest({ refresh_token }))
          // Atualiza o header com o novo token
          originalRequest.headers.Authorization = `Bearer ${token}`
          return axios(originalRequest)
        } else {
          await dispatch(signOut())
          return
        }
      }

      return Promise.reject(error)
    },
    [dispatch, refresh_token, token]
  )

  useEffect(() => {
    // Request interceptors: Garante que o token correto seja usado
    const ecommerceReqInterceptor = ecommerceApi.interceptors.request.use(reqInterceptor)
    const learningReqInterceptor = learningApi.interceptors.request.use(reqInterceptor)
    const coreReqInterceptor = coreApi.interceptors.request.use(reqInterceptor)

    // Response interceptors: Gerencia erros e refresh de token
    const ecommerceResInterceptor = ecommerceApi.interceptors.response.use(
      resInterceptor,
      errInterceptor
    )
    const learningResInterceptor = learningApi.interceptors.response.use(
      resInterceptor,
      errInterceptor
    )
    const coreResInterceptor = coreApi.interceptors.response.use(resInterceptor, errInterceptor)

    return () => {
      // Cleanup: Remove todos os interceptors
      ecommerceApi.interceptors.request.eject(ecommerceReqInterceptor)
      learningApi.interceptors.request.eject(learningReqInterceptor)
      coreApi.interceptors.request.eject(coreReqInterceptor)

      ecommerceApi.interceptors.response.eject(ecommerceResInterceptor)
      learningApi.interceptors.response.eject(learningResInterceptor)
      coreApi.interceptors.response.eject(coreResInterceptor)
    }
  }, [dispatch, errInterceptor, refresh_token, resInterceptor, reqInterceptor])

  return null
}

export { ApiInterceptor, ecommerceApi, learningApi, coreApi }
